exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "auth .login-container{max-width:440px;min-width:340px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/auth/auth.scss
// module id = 179
// module chunks = 0